import PropTypes from "prop-types";

import MDBox from "shared/ui/Box/MDBox";
import MDTypography from "shared/ui/Typography/MDTypography";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { alpha } from "@mui/material/styles";
import { formatDate } from "utils/formatDate";

function ProgramRow({ program, isSelected, onSelect, onOpenMenu, onDoubleClick }) {
  return (
    <MDBox
      display="grid"
      gridTemplateColumns="3fr 2fr 2fr 2fr 48px"
      px={2}
      py={1.5}
      onClick={onSelect}
      onDoubleClick={onDoubleClick}
      sx={{
        userSelect: "none",
        cursor: "pointer",
        borderBottom: "1px solid",
        borderColor: "grey.200",

        backgroundColor: isSelected
          ? (theme) => alpha(theme.palette.primary.main, 0.1)
          : "transparent",
        position: "relative",

        "&::before": {
          content: '""',
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "4px",
          backgroundColor: isSelected ? "primary.main" : "transparent",
        },

        transition: "background-color 0.2s ease, border-left 0.2s ease",

        "&:hover": {
          backgroundColor: isSelected
            ? (theme) => alpha(theme.palette.primary.main, 0.15)
            : "grey.100",
        },
      }}
    >
      <MDTypography variant="body2" fontWeight="medium">
        {program.title}
      </MDTypography>

      <MDTypography variant="body2" color="text.secondary">
        {program.clientName}
      </MDTypography>

      <MDTypography variant="body2" color="text.secondary">
        {formatDate(program.startDate)}
      </MDTypography>

      <MDTypography variant="body2" color="text.secondary">
        {formatDate(program.endDate)}
      </MDTypography>

      <MDBox textAlign="center">
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onOpenMenu(e, program.id);
          }}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </MDBox>
    </MDBox>
  );
}

ProgramRow.propTypes = {
  program: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    clientName: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onOpenMenu: PropTypes.func.isRequired,
  onDoubleClick: PropTypes.func.isRequired,
};

export default ProgramRow;
